module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-5-860644a607252e21e23705da2c5be294.webp";